import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import garbage from "../../assets/images/garbage.svg";
import { folderService } from "services/folder.service";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { notificationService } from "services/notification.service";
const DeleteNotification = (props) => {
    const { show, handleClose,  data, setData,id } = props;
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const handleDelete = async (id) => {

        try {
          const response = await notificationService.deleteNotification(id)
          if (response?.data?.success) {
            toast.success(response?.data?.message);
            handleClose()
            const updatedNotification = data?.notifications?.filter(item => item?._id !== id)
            setData({
              totalNotifications: updatedNotification?.length,
              notifications: updatedNotification
            })
          } else {
            toast.warning(response?.data?.message);
          }
        }
        catch (err) {
          console.log(err?.response?.data?.data?.message)
        }
      }
  return (
    <div>
          <Modal show={show} className="modal-common delete-pop" onHide={handleClose}>
        <Modal.Body>
          <div className="text-center">
            <div className="garbage-box d-flex justify-content-center align-items-center">
              <img alt="" src={garbage} />
            </div>
            <h2 className="mb-3">Delete Notification</h2>
            <p>Are you sure you want to delete this Notification?</p>
            <div className="d-flex flex-wrap gap-2 mt-4">
              <button className="btn blue-btn" onClick={handleClose}>
                No
              </button>
              <button className="btn gray-btn" onClick={(e,item)=>{
                  e.stopPropagation()
                  handleDelete(id)
              }}>
                Yes
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default DeleteNotification
